import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { SpinnerService } from '../../spinner-load/spinner.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { EXTENSIONS, mimeExtensionMap } from '../eml/eml-preview.component';
import { DocPreviewUtilityService } from '../doc-preview-utility.service';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { FileGenericData } from '../file';
import { Title } from '@angular/platform-browser';
import { UserProfileFlagStore } from 'src/app/utility/store/user-profile-flag';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';

@Component({
  selector: 'main [app-zip-preview]',
  templateUrl: './zip-preview.component.html',
  host: { '[attr.id]': '\'content\'' },
  styleUrls: ['./zip-preview.component.css']
})
export class ZipPreviewComponent {
  files: Array<FileGenericData> = []
  filesTemp: Array<FileGenericData> = []
  isAllegatoPreview = false;
  infoStateStore:any = null;
  breadCrumb: Array<{livello: Array<FileGenericData>, nomeFile: string, id: string}> = [];
  activeIndex: number = 0;
  constructor(
    private helpers: HelpersService,
    private route: ActivatedRoute,
    private spinner: SpinnerService, 
    private viewManager: ViewManagerService,
    private zipUtility: DocPreviewUtilityService,
    private router: Router,
    private title: Title,
    private dialog: DialogService
  ) {}

  generateEncodedId(obj: any): string {
    const json = JSON.stringify(obj);
    const base64 = btoa(unescape(encodeURIComponent(json))); // Unicode-safe
    return base64;
  }


  ngOnInit(){
    this.viewManager.svuotaMenu();
    this.viewManager.showHeader();
    window.opener?.postMessage('child_ready', window.location.origin);
    window.addEventListener('message', this.onMessageReceived.bind(this), false);
    const nomeFile = this.route.snapshot.queryParamMap.get('nomeFile');
    this.title.setTitle("Teleforum - " + nomeFile);
    this.route.data.subscribe((data) => {
      if(!!data['documento'] && typeof data['documento'] === "object") {
        this.files = data['documento'];
        let newObject = {livello: data['documento'], nomeFile: nomeFile, id: this.generateEncodedId(data['documento'])}
        let found = this.breadCrumb.findIndex(itm => itm.id === newObject.id) > -1;
        if(!found) {
          this.breadCrumb.push(newObject);
        }
        this.activeIndex = this.breadCrumb.findIndex(itm => itm.id === newObject.id);
        this.filesTemp = data['documento'];
      }
    });
  }

  onMessageReceived(event: MessageEvent) {
    if (event.origin !== window.location.origin) {
      console.warn('Origine non valida:', event.origin);
      return;
    }
    if(!!event?.data?.content) {
      let buffer;
      if(event?.data?.content instanceof ArrayBuffer) {
        buffer = event?.data?.content;
      } else {
        buffer = this.zipUtility.base64ToUint8Array(event?.data?.content);
      }
      this.spinner.show();
      this.zipUtility.onFileZipSelected(buffer).then(
        res => {
          this.files = res;
          let newObject = {livello: res, nomeFile:event?.data?.name, id: this.generateEncodedId(res)}
          let found = this.breadCrumb.findIndex(itm => itm.id === newObject.id) > -1;
          if(!found) {
            this.breadCrumb.push(newObject);
          }
          this.activeIndex = this.breadCrumb.findIndex(itm => itm.id === newObject.id);
          this.filesTemp = res;
        }
      )
    }
  }

  openAttachmentPreview(doc: {
    description: string;
    name: string;
    content: any;
    mimeType: string;
  }, ext = null) {
    const filename = doc.name;
    const extension = ext ? ext : filename.substring(filename.lastIndexOf('.') + 1);
    switch (extension) {
      case EXTENSIONS.EML:
        const newWindow = window.open(`${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#/${UrlSettingsCore.URL_EML_FILE_PREVIEW}/buffer?nomeFile=${doc.name}`, '_blank');
        const payload = doc;
        const listener = (event: MessageEvent) => {
          if (event.origin !== window.location.origin) return;
          if (event.data === 'child_ready') {
            newWindow?.postMessage(payload, window.location.origin);
            window.removeEventListener('message', listener);
          }
        };
        window.addEventListener('message', listener, false);
        break;
      case EXTENSIONS.ZIP:
        this.getDocPreviewByBuffer(doc.content, doc.name)
        break;
      case EXTENSIONS.PDF:
        doc.content = this.zipUtility.arrayBufferToBase64(doc.content);
        this.openExitPreview(doc, UrlSettingsCore.URL_PDF_FILE_PREVIEW);
        break;
      case EXTENSIONS.P7M:
        this.handleP7m(doc);
        break;
      default:
        this.dialogNoPreview();
        break;
    }
  }

  private handleP7m(doc: { description: string; name: string; content: any; mimeType: string; }) {
    let body = { fileData: {} };
    let content = doc.content;
    const base64Content = this.zipUtility.arrayBufferToBase64(content);
    body.fileData["content"] = base64Content;
    body.fileData["nomeFile"] = doc.name;
    body.fileData["contentType"] = doc.mimeType;
    body.fileData["descrizione"] = doc.description;
    this.zipUtility.extractPdfFromP7m(body).subscribe(
      res => {
        const contentDisposition = res.headers.get('Content-Disposition');
        const { filename, extension } = this.zipUtility.parseContentDisposition(contentDisposition);
        let docNew = {
          content: this.zipUtility.arrayBufferToBase64(res.body),
          mimeType: doc.mimeType,
          description: doc.description,
          name: doc.name
        };
        // doc.content = this.zipUtility.arrayBufferToBase64(res.body);
        if (extension === EXTENSIONS.PDF) {
          this.openExitPreview(docNew, UrlSettingsCore.URL_PDF_FILE_PREVIEW);
        } else {
          this.openAttachmentPreview(docNew, extension);
        }
      }
    );
  }

  private dialogNoPreview() {
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: "Anteprima non supportata per questo documento",
          hideButtons: true,
          confirmButton: true
        },
        style: { width: "30%" },
        title: "Errore",
      }
    });
  }

  private openExitPreview(doc: { 
    description: string; 
    name: string;
    content: any; 
    mimeType: string; 
    filename?: string; }, 
    route) {
    const newWindow = window.open(`${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#/${route}/buffer?nomeFile=${doc.name}`, '_blank');
    const payload = {
      content: doc.content,
      name: doc.description || doc.filename || doc.name,
      mimeType: doc.mimeType
    };

    const listener = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data === 'child_ready') {
        newWindow?.postMessage(payload, window.location.origin);
        window.removeEventListener('message', listener);
      }
    };
    window.addEventListener('message', listener, false);
  }

  async getDocPreviewByBuffer(content: ArrayBuffer, name: string) {
    this.spinner.show;
    let files = await this.zipUtility.onFileZipSelected(content);
    this.files = files;
    let newObject = {livello: files, nomeFile: name, id: this.generateEncodedId(files)}
    let found = this.breadCrumb.findIndex(itm => itm.id === newObject.id) > -1;
    if(!found) {
      this.breadCrumb.push(newObject);
    }
    this.activeIndex = this.breadCrumb.findIndex(itm => itm.id === newObject.id);
    this.spinner.hide();
  }

  showMainAttachment() {
    this.isAllegatoPreview = false;
    this.files = this.filesTemp;
  }

  openDynamicFile(file: {
    name: string;
    content: ArrayBuffer | string;
    mimeType: string;
  }) {
    let blob: any;
    if (typeof file.content !== "string") {
      blob = new Blob([file.content], { type: file.mimeType });
    } else {
      const byteArray = this.zipUtility.base64ToUint8Array(file.content);
      blob = new Blob([byteArray], { type: file.mimeType });
    }
    const url = URL.createObjectURL(blob);
    window.open(url);
  }

  grabState(index: number) {
    this.files = this.breadCrumb[index].livello;
    this.activeIndex = index;
  }

  canViewFile(file){
    const extension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
    if(extension !== "pdf" && extension !== "eml" && extension !== "zip" && extension !== "p7m") return false;
    let maxPreviewSize = this.zipUtility.findMaxSizeByContentype(file.mimeType);
    // controllo che il contenuto del file non superi la dimensione massima consentita
    if(file.content.byteLength > Number(!!maxPreviewSize ? maxPreviewSize : file.content.byteLength)) {
      file["maxLimitExceeded"] = true;
      return false;
    };
    return true;
  }
}
